import React, { useMemo } from 'react';
import { isEmpty } from 'ramda';
import BreadcrumbsItem from '../Breadcrumbs/BreadcrumbsItem';
import BreadcrumbsItemRoot from '../Breadcrumbs/BreadcrumbsItemRoot';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { useBreadcrumbs } from '../../../components/Breadcrumbs/hooks';
import { ROOT, GAME } from '../../../constants/routeTemplates';
import { useIsDesktopLayout } from '../../../hooks/useMediaQuery';

const disabledRoutesDesktop = [ROOT];
const disabledRoutesMobile = [ROOT, GAME];

const SEOWrapperBreadcrumbs = ({ className }) => {
  const isDesktop = useIsDesktopLayout();
  const disabledRoutes = useMemo(
    () => (isDesktop ? disabledRoutesDesktop : disabledRoutesMobile),
    [isDesktop]
  );
  const breadcrumbs = useBreadcrumbs(disabledRoutes);

  if (isEmpty(breadcrumbs)) {
    return null;
  }

  const breadcrumbsWithoutRoot = breadcrumbs.slice(1);

  return (
    <Breadcrumbs className={className}>
      <BreadcrumbsItemRoot />
      {breadcrumbsWithoutRoot.map((bc) => (
        <BreadcrumbsItem
          key={bc.title}
          to={bc.link}
          isActive={bc.active}
          isExternal={bc.isExternal}
        >
          {bc.title}
        </BreadcrumbsItem>
      ))}
    </Breadcrumbs>
  );
};

export default SEOWrapperBreadcrumbs;
